import React from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled as muiStyled } from "@mui/material/styles";
import { colors } from "../../utils";
import IyugaTooltip from "../IyugaTooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const StyledTabs = muiStyled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: (
        <span className="MuiTabs-indicatorSpan" style={{ bottom: 45 }} />
      ),
    }}
  />
))({
  borderBottom: "1px solid #E0E0E0",
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: colors.PrimaryPurple500,
  },
});

const StyledTab = muiStyled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    maxWidth: "fit-content",
    minWidth: 0,
    fontWeight: 400,
    fontSize: "14px",
    marginRight: theme.spacing(1),
    lineHeight: "20px",
    fontFamily: '"DM Sans", sans-serif',
    color: "#98A2B3",
    backgroundColor: colors.white,
    "&.Mui-selected": {
      color: colors.PrimaryPurple800,
      backgroundColor: colors.white,
      fontWeight: 400,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);

// Create a styled component for the tab label with info icon
const TabLabelWithInfo = muiStyled("div")({
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export default function CustomTabs({ onChange, value, tabs, tooltips = {} }) {
  return (
    <StyledTabs
      value={value}
      onChange={onChange}
      aria-label="styled tabs example"
    >
      {tabs.map((item, index) => {
        const hasTooltip = tooltips && tooltips[item];

        const labelContent = hasTooltip ? (
          <TabLabelWithInfo>
            {item}
            <IyugaTooltip tooltip={tooltips[item]} placement="top" arrow>
              <InfoOutlinedIcon
                sx={{
                  color: "#9B5AF8",
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                }}
              />
            </IyugaTooltip>
          </TabLabelWithInfo>
        ) : (
          item
        );

        return <StyledTab key={index} label={labelContent} />;
      })}
    </StyledTabs>
  );
}
